module.exports = __webpack_public_path__ + "img/jht-icon-15.00e57ff4.png";